export const globalAlertReducer = (state, { type, payload }) => {
  switch (type) {
    case 'CLOSE':
      return { ...state, [payload]: true }
    default:
      return state
  }
}
